import {
  faFlag,
  faHourglassEnd,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import styled from 'styled-components'

import { FraudDecision, FraudStatus } from '@/types/Activity'

import { toFraudDecisionColour, toFraudStatusColour } from './Colours'
import { FRAUD_DECISION_LABELS } from './labels'

const Container = styled.div<{ colour: string }>`
  background: ${props => props.colour};
  color: white;
  padding: 10px;
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: 10px;
`

interface Props {
  status: FraudStatus
  fraudDecision?: FraudDecision | null
}

const isMediumRisk = (decision: FraudDecision | null | undefined): boolean =>
  decision === FraudDecision.internalRiskMediumRisk

const FraudFlag: FC<Props> = ({ status, fraudDecision }) => {
  const decisionLabel = fraudDecision ? FRAUD_DECISION_LABELS[fraudDecision] : null

  const colour =
    status === FraudStatus.confirmed && fraudDecision
      ? toFraudDecisionColour[fraudDecision]
      : toFraudStatusColour[status]

  return (
    <Container colour={colour}>
      {status === FraudStatus.awaitingFraudTeamReview && (
        <>
          <div>
            <FontAwesomeIcon size="1x" icon={faHourglassEnd} />
          </div>
          <div>
            <strong>Warning:</strong> This applicant is pending fraud team investigation.
          </div>
        </>
      )}
      {status === FraudStatus.potential && (
        <>
          <div>
            <FontAwesomeIcon size="1x" icon={faTriangleExclamation} />
          </div>
          <div>
            <strong>Warning:</strong> This applicant has been marked with suspicions of
            fraud.
          </div>
        </>
      )}
      {status === FraudStatus.confirmed && (
        <>
          <div>
            <FontAwesomeIcon size="1x" icon={faFlag} />
          </div>
          <div>
            {isMediumRisk(fraudDecision) ? (
              <>
                <strong>Warning:</strong> This applicant has been flagged as medium risk.
                {decisionLabel && (
                  <>
                    {' '}
                    <strong>Reason:</strong> {decisionLabel}
                  </>
                )}
              </>
            ) : (
              <>
                <strong>Warning:</strong> This applicant has been confirmed of fraud. Do
                not use!
                {decisionLabel && (
                  <>
                    {' '}
                    <strong>Reason:</strong> {decisionLabel}
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}
    </Container>
  )
}

export default FraudFlag
